/*
  dylaras-back-in-stock.js
  <dylaras-back-in-stock> — subscribes an email to Klaviyo Back in Stock for a variant.
  Uses Klaviyo's public client API; the company (site) ID is read from the Klaviyo onsite
  embed script that the Klaviyo app block already loads on every page.
  Requires Back in Stock to be enabled in Klaviyo, plus a "Back in Stock" flow to send the email.
*/
(() => {
  if (customElements.get('dylaras-back-in-stock')) return;

  const ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  const REVISION = '2024-10-15';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /** Klaviyo site ID from the onsite embed (…/klaviyo.js?company_id=XXXX) */
  function klaviyoCompanyId() {
    const script = document.querySelector('script[src*="klaviyo.js"][src*="company_id="]');
    if (!script) return null;
    return new URL(script.src, location.href).searchParams.get('company_id');
  }

  class DylarasBackInStock extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.status = this.querySelector('.dylaras-bis__status');
      this.form?.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    setStatus(message, state) {
      this.status.textContent = message;
      this.dataset.state = state;
    }

    onSubmit = async (event) => {
      event.preventDefault();
      const email = this.form.email.value.trim();
      if (!EMAIL_RE.test(email)) {
        this.setStatus(this.dataset.msgInvalid, 'error');
        return;
      }

      const companyId = klaviyoCompanyId();
      if (!companyId) {
        this.setStatus(this.dataset.msgError, 'error');
        console.warn('[dylaras-back-in-stock] Klaviyo embed not found on the page');
        return;
      }

      const button = this.form.querySelector('button');
      button.disabled = true;

      try {
        const response = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email } } },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.variantId}` },
                },
              },
            },
          }),
        });

        if (!response.ok) throw new Error(`Klaviyo responded ${response.status}`);
        this.form.hidden = true;
        this.setStatus(this.dataset.msgSuccess, 'success');
      } catch (error) {
        console.warn('[dylaras-back-in-stock]', error);
        this.setStatus(this.dataset.msgError, 'error');
        button.disabled = false;
      }
    };
  }

  customElements.define('dylaras-back-in-stock', DylarasBackInStock);
})();
